module.exports = __webpack_public_path__ + "img/banner-core-value.c0df41dc.png";